module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addRoleLabels
    }
  }, [_vm._v("添加角色")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "角色名称"
    },
    model: {
      value: (_vm.params.role_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "role_name", $$v)
      },
      expression: "params.role_name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.roleSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.rolesList,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "role_name",
      "label": "角色名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "permission",
      "label": "角色权限"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tree', {
          attrs: {
            "data": scope.row.permission_tree,
            "props": _vm.defaultProps
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editRoleAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteRoleAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editRoleTitle,
      "visible": _vm.editRoleVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.editRoleVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "90px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "角色名称"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "订单管理员、商品管理员、等等"
      },
      model: {
        value: (_vm.form.role_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "role_name", $$v)
        },
        expression: "form.role_name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "角色权限"
      }
    }, [_c('el-tree', {
      ref: "tree",
      attrs: {
        "data": _vm.$store.getters.menus,
        "default-checked-keys": _vm.defaultCheckedKeys,
        "node-key": "alias_name",
        "props": _vm.defaultProps,
        "show-checkbox": ""
      }
    })], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitRoleAction
      }
    }, [_vm._v("保存")])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de9d946e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de9d946e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/account/normalroles.vue
// module id = 2946
// module chunks = 0